module.exports = __webpack_public_path__ + "static/img/zw.883b97a7.svg";